(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || !drawer.showModal) return;
  const $ = selector => drawer.querySelector(selector);
  const root = window.Shopify?.routes?.root || '/';
  let adding = false, finalizingAdd = false;
  let confirmedCart = null, pendingItem = null, pendingItems = [];
  let addSettled = null, settleAdd = null, checkoutRequest = null;
  const quantityIntents = new Map();
  let quantityTask = null;
  let cart = null, busy = false, changing = false, reading = null, lastTrigger = null;
  let unmatchedPrint = null;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cart?.currency || 'USD'}).format(Number(cents || 0) / 100);
  const request = async (path, body) => {
    const response = await fetch(root + path, {method:body === undefined ? 'GET' : 'POST', headers:{'Content-Type':'application/json'}, ...(body === undefined ? {} : {body:JSON.stringify(body)}), signal:AbortSignal.timeout(35000)});
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.error || 'Your bag could not be updated. Please try again.');
    return data;
  };
  const isCredit = item => Boolean(item.properties?._pawnted_credit_wallet);
  const lineIdentity = item => item.properties?._pawnted_portrait_id
    ? item.properties._pawnted_portrait_id+':'+String(item.properties._pawnted_base_variant || item.variant_id)
    : item.key;
  const node = (tag, className, text) => { const el=document.createElement(tag); el.className=className; if(text !== undefined)el.textContent=text; return el; };
  const button = (text, className, action, label) => {const el=node('button',className,text);el.type='button';el.onclick=action;if(label)el.setAttribute('aria-label',label);return el;};
  function syncControls() {
    const blocked=busy || adding || finalizingAdd || Boolean(checkoutRequest);
    const studio=window.PawntedStudio, state=studio?.getState();
    drawer.setAttribute('aria-busy',String(blocked));
    drawer.querySelectorAll('[data-drawer-items] button').forEach(el=>{el.disabled=Boolean(checkoutRequest) || !cart || (busy && !adding && !changing && !finalizingAdd) || el.dataset.limit === 'true';});
    $('[data-drawer-checkout]').disabled=Boolean(checkoutRequest) || (busy && !adding && !changing && !finalizingAdd) || !cart?.items?.length;
    if(cart)$('[data-drawer-checkout]').textContent=checkoutRequest ? 'Opening checkout…' : 'Checkout · '+money(cart.total_price);
    $('[data-drawer-checkout]').hidden=Boolean(cart && !cart.items.length);
    $('[data-drawer-create]').disabled=blocked;
    $('[data-drawer-create]').textContent=!studio ? 'Explore more styles' : state.busy ? 'Back to your portrait' : state.hasPortrait ? 'Create another artwork' : 'Keep creating';
    $('[data-drawer-more]').hidden=!cart?.items?.some(item=>!isCredit(item));
    $('[data-drawer-styles]').disabled=blocked || Boolean(state?.busy);
    if($('[data-drawer-second-artwork]'))$('[data-drawer-second-artwork]').disabled=blocked || Boolean(state?.busy);
    for(const name of ['same','saved']){const button=$('[data-drawer-pair-'+name+']');if(button)button.disabled=blocked || Boolean(state?.busy) || !studio;}
    $('[data-drawer-library]').hidden=!state?.libraryCount;
    $('[data-drawer-library]').disabled=blocked || Boolean(state?.busy);
    $('[data-drawer-topup]').hidden=!studio || !cart?.items?.some(item=>!isCredit(item)) || cart.items.some(isCredit) || state?.credits?.total !== 0;
    $('[data-drawer-add-credits]').disabled=blocked || Boolean(state?.busy);
    $('[data-drawer-retry]').disabled=blocked;
  }
  function render(data, optimistic = false) {
    if (!Array.isArray(data.items) || !Number.isFinite(data.total_price)) throw new Error('Could not load your bag. Please try again.');
    if (!optimistic) confirmedCart = data;
    cart=quantityIntents.size ? withQuantities(data) : data;
    const displayItems=[...cart.items].sort((a,b)=>Number(isCredit(a))-Number(isCredit(b)));
    $('[data-drawer-items]').replaceChildren(...displayItems.map(item=>{
      const credit=isCredit(item), title=credit ? '20 portrait generations' : item.product_title || item.title || 'Your portrait';
      const row=node('article','pw-cart-line');row.dataset.drawerLine=item.key;
      const thumbnail=node('div','pw-cart-thumbnail');
      if(credit) thumbnail.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8" cy="8" r="1.5"/><path d="m3 17 5-5 4 4 3-3 6 6"/></svg>';
      else {
        const src=item.properties?._pawnted_preview || item.properties?._pawnted_preview_url || item.featured_image?.url || item.image;
        if(typeof src === 'string') { try { const url=new URL(src,location.origin);if(['https:','http:','blob:'].includes(url.protocol)){
          const img=node('img','');img.alt=title;img.decoding='async';
          thumbnail.dataset.loading='true';thumbnail.setAttribute('aria-busy','true');
          const spinner=node('span','pw-cart-thumbnail-loader');spinner.setAttribute('role','status');spinner.setAttribute('aria-label','Loading artwork thumbnail');thumbnail.append(spinner);
          const settle=()=>{delete thumbnail.dataset.loading;thumbnail.removeAttribute('aria-busy');spinner.remove();};
          img.onload=settle;img.onerror=()=>{settle();img.hidden=true;thumbnail.append(node('span','pw-cart-thumbnail-fallback','Your artwork'));};
          img.src=url.href;thumbnail.append(img);if(img.complete&&img.naturalWidth)settle();
        }} catch {} }
      }
      const detail=node('div','pw-cart-line-copy');detail.append(node('h3','',title));
      const variant=item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      detail.append(node('p','pw-cart-line-detail',credit ? `${item.quantity * 20} generations · available after payment. Prints sold separately.` : variant));
      if(!credit && item.properties?.['Free gift']){const gift=node('p','pw-cart-line-gift');gift.append(node('span','','+ Free digital print'),node('strong','','FREE'));detail.append(gift);}
      const price=node('p','pw-cart-line-price');
      if(item.original_line_price>item.final_line_price) price.append(node('s','',money(item.original_line_price)));
      price.append(node('strong','',money(item.final_line_price)));detail.append(price);
      const controls=node('div','pw-cart-line-controls'), quantity=node('div','pw-cart-quantity');quantity.setAttribute('role','group');quantity.setAttribute('aria-label','Quantity for '+title);
      const less=button('−','',()=>change(item.key,item.quantity-1),'Decrease quantity of '+title), more=button('+','',()=>change(item.key,item.quantity+1),'Increase quantity of '+title);
      more.dataset.limit=String(item.quantity>=10);
      quantity.append(less,node('span','',String(item.quantity)),more);
      controls.append(quantity,button('Remove','pw-cart-remove',()=>change(item.key,0),'Remove '+title));detail.append(controls);row.append(thumbnail,detail);return row;
    }));
    const count=cart.item_count ?? cart.items.reduce((n,item)=>n+item.quantity,0);
    $('[data-drawer-count]').textContent=String(count);
    $('[data-drawer-subtotal]').textContent=money(cart.total_price)+' '+(cart.currency || 'USD');
    $('[data-drawer-checkout]').textContent='Checkout · '+money(cart.total_price);
    $('[data-drawer-empty]').hidden=Boolean(cart.items.length);
    $('[data-drawer-totals]').hidden=!cart.items.length;
    const printCount=cart.items.filter(item=>/^(std-|can-)/.test(item.sku || '') && !isCredit(item)).reduce((n,item)=>n+item.quantity,0);
    if($('[data-drawer-pair-offer]')) {
      $('[data-drawer-pair-offer]').hidden=!printCount;
      const groups=new Map();for(const item of cart.items){if(isCredit(item)||!item.properties?._pawnted_portrait_id||!/^(std-|can-)/.test(item.sku||''))continue;const id=String(item.properties._pawnted_base_variant||item.variant_id);if(!groups.has(id))groups.set(id,[]);groups.get(id).push(item);}
      unmatchedPrint=[...groups.values()].find(lines=>lines.reduce((n,item)=>n+item.quantity,0)%2===1)?.[0]||null;
      if($('[data-pair-cart-title]'))$('[data-pair-cart-title]').textContent=unmatchedPrint?'Save on a second print':'Your prints are ready';
      if($('[data-pair-cart-copy]'))$('[data-pair-cart-copy]').textContent=unmatchedPrint?'Add another '+(unmatchedPrint.variant_title||'print in the same size and finish')+' and save. Different artwork welcome.':'Matching pairs receive their saving automatically. Single prints are welcome too.';
      if($('[data-drawer-second-artwork]'))$('[data-drawer-second-artwork]').hidden=!unmatchedPrint;
      if($('.pw-cart-pair-actions'))$('.pw-cart-pair-actions').hidden=!unmatchedPrint;
    }
    $('[data-drawer-shipping]').hidden=!cart.items.some(item=>!isCredit(item) && item.requires_shipping !== false);
    $('[data-drawer-tax]').textContent=cart.items.some(isCredit) ? 'Credits unlock after payment. Any taxes calculated at checkout.' : 'Any taxes calculated at checkout.';
    document.querySelectorAll('.atelier-bag').forEach(link=>{link.setAttribute('aria-label','Shopping bag, '+count+' items');const badge=link.querySelector('span');if(badge)badge.textContent=String(count);});
    syncControls();
    if(!optimistic)window.dispatchEvent(new CustomEvent('pawnted:cart-updated',{detail:{cart:data}}));
  }
  function withQuantities(data) {
    const items=data.items.map(item=>{
      const intent=quantityIntents.get(lineIdentity(item));
      if(!intent)return item;
      const price=Number(item.original_price ?? item.price ?? item.original_line_price/item.quantity);
      const finalPrice=Number(item.final_price ?? item.price ?? item.final_line_price/item.quantity);
      return {...item,quantity:intent.quantity,original_line_price:price*intent.quantity,final_line_price:finalPrice*intent.quantity};
    }).filter(item=>item.quantity>0);
    return instantPairCart({...data,items,item_count:items.reduce((n,item)=>n+item.quantity,0)});
  }
  function hydrateAdd(data) {
    if(!adding||!pendingItems.length)return;
    confirmedCart=data;
    const items=data.items.map(item=>({...item}));
    for(const incoming of pendingItems) {
      const matches=items.filter(item=>lineIdentity(item)===lineIdentity(incoming));
      const existing=matches.reduce((n,item)=>n+item.quantity,0),needed=Math.max(0,incoming.quantity-existing);
      if(!needed)continue;
      if(matches.length){const line=matches[0];line.quantity+=needed;line.original_line_price=line.final_line_price=Number(line.original_price??line.price)*line.quantity;}
      else items.push({...incoming});
    }
    render(instantPairCart({...data,items,item_count:items.reduce((n,item)=>n+item.quantity,0)}),true);
  }
  // Mirror the native fixed saving for each matching pair while a cart write is pending.
  // The server's confirmed cart remains authoritative, including currency conversion.
  function instantPairCart(data) {
    const items=data.items.map(item=>({...item})), groups=new Map();
    if(data.currency && data.currency !== 'USD')return {...data,items,total_price:items.reduce((n,item)=>n+item.final_line_price,0)};
    items.forEach((item,index)=>{
      const offer=window.PawntedPrintPricing?.[item.sku];
      const price=Number(item.original_price??item.price??item.original_line_price/item.quantity);
      if(isCredit(item)||!offer||price!==offer.single)return;
      item.original_line_price=item.final_line_price=price*item.quantity;
      if(!groups.has(item.sku))groups.set(item.sku,{offer,units:[]});
      for(let n=0;n<item.quantity;n++)groups.get(item.sku).units.push(index);
    });
    for(const {offer,units} of groups.values()) {
      const saving=2*offer.single-offer.pair;
      for(let n=0;n<Math.floor(units.length/2);n++)items[units[n]].final_line_price-=saving;
    }
    return {...data,items,total_price:items.reduce((n,item)=>n+item.final_line_price,0)};
  }
  async function refresh(announcement = '') {
    if(changing || adding)return false;
    if(reading)return reading;
    busy=true;syncControls();$('[data-drawer-retry]').hidden=true;$('[data-drawer-status]').textContent=cart?.items?.length?'':'Loading your bag…';
    reading=(async()=>{
      try {const data=await request('cart.js');if(adding)return false;render(data);$('[data-drawer-status]').textContent=announcement;return true;}
      catch(error){if(adding)return false;cart=null;$('[data-drawer-items]').replaceChildren();$('[data-drawer-totals]').hidden=true;$('[data-drawer-empty]').hidden=true;$('[data-drawer-status]').textContent=error.message;$('[data-drawer-retry]').hidden=false;return false;}
      finally {busy=false;reading=null;syncControls();}
    })();return reading;
  }
  async function open({trigger,announcement,pending=false,item=null,items=null}={}) {
    if(!drawer.open){lastTrigger=trigger || document.activeElement;drawer.showModal();document.documentElement.classList.add('pw-cart-open');$('[data-drawer-close]').focus({preventScroll:true});}
    $('[data-checkout-status]').hidden=true;
    if(pending){
      if(!adding)addSettled=new Promise(resolve=>{settleAdd=resolve;});
      adding=true;pendingItem=item;pendingItems=items|| (item?[item]:[]);
      if(pendingItems.length)hydrateAdd(confirmedCart||{items:[],item_count:0,total_price:0,currency:'USD'});
      $('[data-drawer-empty]').hidden=true;$('[data-drawer-retry]').hidden=true;
      $('[data-drawer-status]').textContent='';syncControls();return;
    }
    return refresh(announcement);
  }
  function close() {drawer.close();}
  drawer.addEventListener('close',()=>{checkoutRequest=null;syncControls();document.documentElement.classList.remove('pw-cart-open');if(lastTrigger?.isConnected)lastTrigger.focus({preventScroll:true});});
  drawer.addEventListener('keydown',event=>{
    if(event.key!=='Tab')return;
    const controls=[...drawer.querySelectorAll('button,a[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')].filter(el=>!el.disabled && el.getClientRects().length);
    const first=controls[0],last=controls.at(-1);
    if(event.shiftKey && document.activeElement===first){event.preventDefault();last?.focus();}
    else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first?.focus();}
  });
  drawer.addEventListener('click',event=>{if(event.target===drawer){const r=drawer.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}});
  $('[data-drawer-close]').onclick=close;
  $('[data-drawer-retry]').onclick=()=>refresh();
  function change(key,quantity) {
    if(checkoutRequest || (busy && !adding && !changing && !finalizingAdd) || !cart || !Number.isInteger(quantity) || quantity<0 || quantity>10)return;
    const item=cart.items.find(item=>item.key===key);if(!item)return;
    quantityIntents.set(lineIdentity(item),{quantity});
    const label=document.activeElement?.getAttribute('aria-label');
    render(cart,true);$('[data-checkout-status]').hidden=true;$('[data-drawer-status]').textContent='';
    const row=[...drawer.querySelectorAll('[data-drawer-line]')].find(el=>el.dataset.drawerLine===key);
    ([...row?.querySelectorAll('button') || []].find(el=>el.getAttribute('aria-label')===label) || $('[data-drawer-close]')).focus({preventScroll:true});
    if(!adding && !finalizingAdd)void saveQuantities();
  }
  function saveQuantities() {
    if(quantityTask)return quantityTask;
    if(adding || !quantityIntents.size)return Promise.resolve(true);
    busy=true;changing=true;syncControls();
    quantityTask=Promise.resolve().then(async()=>{
      try {
        while(quantityIntents.size){
          const [identity,intent]=quantityIntents.entries().next().value;
          const line=confirmedCart?.items.find(item=>lineIdentity(item)===identity);
          if(!line){if(intent.quantity!==0)throw new Error('This item could not be saved. Please add it again.');quantityIntents.delete(identity);continue;}
          let data;
          try {data=await request('cart/change.js',{id:line.key,quantity:intent.quantity});}
          catch(error){
            data=await request('cart.js');confirmedCart=data;
            const saved=data.items.find(item=>lineIdentity(item)===identity);
            if((saved?.quantity || 0)!==intent.quantity)throw error;
          }
          if(quantityIntents.get(identity)===intent)quantityIntents.delete(identity);
          render(data);
        }
        $('[data-drawer-status]').textContent='';return true;
      }catch(error){
        quantityIntents.clear();if(confirmedCart)render(confirmedCart);
        $('[data-drawer-status]').textContent=error.message;$('[data-drawer-retry]').hidden=false;cart=null;return false;
      }finally{busy=false;changing=false;quantityTask=null;syncControls();}
    });return quantityTask;
  }
  function continueCreating(action) {
    if(busy || adding)return;
    const studio=window.PawntedStudio;close();
    // Let the modal restore its previous focus before focusing the studio destination.
    requestAnimationFrame(()=>{
      if(action==='second-artwork') {
        if(studio?.startCartPair && unmatchedPrint)void studio.startCartPair(unmatchedPrint,'create');
        else {
          if(unmatchedPrint){try{sessionStorage.setItem('pawnted-print-pair-v2',JSON.stringify({first:unmatchedPrint.properties._pawnted_portrait_id,variantId:unmatchedPrint.properties._pawnted_base_variant||unmatchedPrint.variant_id,fromCart:true,awaitingNew:true,at:Date.now()}));}catch{}}
          if(window.PawntedFunnel)window.PawntedFunnel.showStyles();else location.assign(root+'pages/create');
        }
      } else if(studio)studio.continueCreating(action);else location.assign(root+'#styles');
    });
  }
  $('[data-drawer-create]').onclick=()=>continueCreating('create');
  $('[data-drawer-styles]').onclick=()=>continueCreating('styles');
  if($('[data-drawer-second-artwork]'))$('[data-drawer-second-artwork]').onclick=()=>continueCreating('second-artwork');
  for(const action of ['same','saved']){const button=$('[data-drawer-pair-'+action+']');if(button)button.onclick=()=>{if(busy||adding||!unmatchedPrint)return;const line=unmatchedPrint;close();requestAnimationFrame(()=>void window.PawntedStudio?.startCartPair(line,action));};}
  $('[data-drawer-library]').onclick=()=>continueCreating('library');
  $('[data-drawer-add-credits]').onclick=async()=>{
    if(busy || adding || !window.PawntedStudio)return;
    busy=true;syncControls();
    try {const result=await window.PawntedStudio.addCredits();if(result?.error)$('[data-drawer-status]').textContent=result.error;}
    finally {busy=false;syncControls();}
  };
  $('[data-drawer-checkout]').onclick=async()=>{
    if(checkoutRequest || (busy && !adding && !changing && !finalizingAdd) || !cart?.items?.length)return;
    const intent={};checkoutRequest=intent;syncControls();
    try {
      if(adding || finalizingAdd){
        const status=$('[data-checkout-status]');status.hidden=true;status.textContent='';
        const saved=await addSettled;
        if(checkoutRequest!==intent)return;
        status.hidden=true;
        if(!saved)return;
      }
      if(quantityTask || quantityIntents.size){if(!await saveQuantities())return;}
      if(checkoutRequest!==intent || !cart?.items?.length)return;
      if(!window.PawntedCheckout?.checkout)throw new Error('Checkout is still loading. Please try again.');
      await window.PawntedCheckout.checkout($('[data-drawer-checkout]'));
    }
    catch(error){$('[data-drawer-status]').textContent=error.message;}
    finally {if(checkoutRequest===intent)checkoutRequest=null;syncControls();}
  };
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');
    if(!link || event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
    const url=new URL(link.href,location.href);
    if(url.origin!==location.origin || url.pathname!==root+'cart' || url.search)return;
    event.preventDefault();void open({trigger:link});
  });
  window.addEventListener('pageshow',()=>{if(drawer.open)void refresh();});
  document.querySelectorAll('.atelier-bag,[data-studio-bag],[data-view-bag]').forEach(link=>{link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-controls',drawer.id);});
  async function finishAdd(announcement, succeeded = true) {
    const resolve=settleAdd;settleAdd=null;finalizingAdd=true;
    if(reading)await reading;
    adding=false;
    pendingItem=null;
    pendingItems=[];
    const refreshed=await refresh(announcement);
    if(!succeeded || !refreshed){quantityIntents.clear();if(refreshed)render(confirmedCart);}
    const quantitiesSaved=succeeded && refreshed ? await saveQuantities() : false;
    finalizingAdd=false;syncControls();
    resolve?.(succeeded && refreshed && quantitiesSaved);
    return refreshed;
  }
  window.PawntedCart={open,refresh,syncControls,finishAdd,hydrateAdd};
})();
